var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LayoutHeader',{attrs:{"activeNav":"数字艺术馆","topColor":_vm.topColor,"bannerType":"header museum"}}),_c('div',{staticClass:"container"},[_vm._v(" 敬请期待 ")]),_c('LayoutFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }